'use strict';

angular.module('app.createAccount', [])
    .controller('createAccountCtrl', ['$scope', '$rootScope', '$http', '$modalInstance', '$modal', 'adminService', 'accountDetailsService', 'userAndBillingOverviewService', 'createAccountService', 'subscriptionAndBillingService',
        function ($scope, $rootScope, $http, $modalInstance, $modal, adminService, accountDetailsService, userAndBillingOverviewService, createAccountService, subscriptionAndBillingService) {

            var definitions = angular.copy($rootScope.definitions);
            $scope.mailingCountries = definitions.countries;
            $scope.billingCountries = definitions.countries;
            $scope.diffAddBox = false;
            $scope.activeBox = false;
            $scope.accountName = null;
            $scope.accountLevels = [
                {id: 1, name: "Blocked", package: 4, ticked: false},
                {id: 2, name: "Lead", package: 3, ticked: false},
                {id: 3, name: "Customer", package: 2, ticked: false},
            ];

            if ($scope.contactPerson != null) {
                if ($scope.contactPerson.tempCompanyName != null || $scope.contactPerson.tempCompanyName !== undefined) {
                    $scope.accountName = $scope.contactPerson.tempCompanyName;
                }
            }

            $scope.getAccountTypes = function () {
                userAndBillingOverviewService.getAccountTypes(false)
                    .then(function (responseAccountTypes) {
                        $scope.accountTypes = responseAccountTypes.data;
                    }, function (responseAccountTypes) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseAccountTypes.message;
                    })
            }

            $scope.getGoverningAgency = function (params) {
                accountDetailsService.getAllGoverningAgency(false)
                    .then(function (responseAllGoverningAgency) {
                        $scope.governingAgencies = [];
                        var object = {
                            id: null,
                            name: "None"
                        }
                        $scope.governingAgencies.push(object);
                        angular.forEach(responseAllGoverningAgency.data, function (item) {
                            $scope.governingAgencies.push(item);
                        })
                    }, function (responseAllGoverningAgency) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseAllGoverningAgency.message;
                    })
            }

            $scope.getPackages = function () {
                subscriptionAndBillingService.getPackageForFilter(false)
                    .then(function (response) {
                        $scope.packages = response.data;
                        angular.forEach($scope.packages, function (packageItem) {
                            packageItem.ticked = false;
                            if (packageItem.id == 2) {
                                $scope.selectedPackageId = packageItem.id;
                                $scope.accountLevels[2].ticked = true;
                            }
                        })
                    }, function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            $scope.selectAccountType = function (selectedAccountType) {
                $scope.selectedAccountType = selectedAccountType.id;
            }

            $scope.selectPackage = function (selectedPackage) {
                $scope.selectedPackageId = selectedPackage.package;
            }

            $scope.selectGoverningAgency = function (selectedGoverningAgency) {
                $scope.selectedGoverningAgency = selectedGoverningAgency.id;
            }

            $scope.selectMailingCountry = function (selectedMailingCountry) {
                $scope.selectedMailingCountry = selectedMailingCountry.id;
            }

            $scope.selectBillingCountry = function (selectedBillingCountry) {
                $scope.selectedBillingCountry = selectedBillingCountry.id;
            }

            $scope.createAccount = function () {
                var params = {
                    accountId: null,
                    accountType: $scope.selectedAccountType != 0 ? $scope.selectedAccountType : null,
                    vat: $scope.vat,
                    accountName: $scope.accountName,
                    mailingStreet: $scope.mailingStreet,
                    mailingCity: $scope.mailingCity,
                    mailingZipCode: $scope.mailingZipCode,
                    mailingCountry: $scope.selectedMailingCountry != 0 ? $scope.selectedMailingCountry : null,
                    isDiffAddress: $scope.diffAddBox == true ? 1 : 0,
                    billingStreet: $scope.diffAddBox == true ? $scope.billingStreet : $scope.mailingStreet,
                    billingCity: $scope.diffAddBox == true ? $scope.billingCity : $scope.mailingCity,
                    billingZipCode: $scope.diffAddBox == true ? $scope.billingZipCode : $scope.mailingZipCode,
                    billingCountry: $scope.diffAddBox == true ? $scope.selectedBillingCountry : $scope.selectedMailingCountry,
                    governingAgency: $scope.selectedGoverningAgency != 0 ? $scope.selectedGoverningAgency : null,
                    contactPersonId: $scope.contactPerson != null ? $scope.contactPerson.id : null,
                    contactPersonName: $scope.contactPerson != null ? $scope.contactPerson.firstName : null,
                    contactPersonPhone: $scope.contactPerson != null ? $scope.contactPerson.phone : null,
                    contactPersonEmail: $scope.contactPerson != null ? $scope.contactPerson.email : null,
                    autoCreateAccountForInfluencerOrNetwork: false,
                    influencerId: null,
                    networkId: null,
                    packageId: $scope.selectedPackageId,
                    isActive: $scope.activeBox == true ? 1 : 2,
                    tempUserFirstName: $scope.tempUserFirstName,
                    tempUserPhone: $scope.tempUserPhone,
                    tempUserEmail: $scope.tempUserEmail
                }

                createAccountService.createAccount(params, true)
                    .then(function (response) {
                        $rootScope.$broadcast('reload_listadvertise');
                        if ($scope.userAccountActionModalInstance != null) {
                            $scope.createAccountModalInstance.close();
                            $scope.userAccountActionModalInstance.close();
                            $scope.getNewUsers();
                        } else {
                            $scope.closeCreateAccountModal();
                            $scope.preLoadData();
                        }
                    }, function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            $scope.closeCreateAccountModal = function () {
                $scope.createAccountModalInstance.close();
            }

            $scope.getAccountTypes();
            $scope.getGoverningAgency();
            $scope.getPackages();
        }
    ])
